module.exports = __webpack_public_path__ + "static/media/feedback.de002f28.svg";